<template>
  <div class="drawer__header" data-js="get-height">
    <v-layout align-center justify-start>
      <v-btn
        v-if="history.length > 1"
        icon
        @click="goBack"
      >
        <v-icon color="gray-6">keyboard_arrow_left</v-icon>
      </v-btn>

      <v-flex class="drawer__title">
        {{ action === 'preview' ? $t(`${namespace}.title`) : $t(`${namespace}.editProject`) }}
      </v-flex>
    </v-layout>

    <div>
      <v-menu
        v-if="
          action === 'preview' &&
          (hasRole('project', 'ROLE_PUT_PROJECT_ID') || hasRole('project', 'ROLE_DELETE_PROJECT_ID'))
        "
        offset-y
        left
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            class="btn--more_vertical"
            icon
          >
            <v-icon color="gray-6">more_vertical</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item
            v-if="hasRole('project', 'ROLE_PUT_PROJECT_ID')"
            @click="handleEditProject"
          >
            <v-list-item-title>
              {{ $t('Common.editProject') }}
            </v-list-item-title>
          </v-list-item>

          <v-divider v-if="hasRole('project', 'ROLE_PUT_PROJECT_ID') && hasRole('project', 'ROLE_DELETE_PROJECT_ID')" />

          <v-list-item
            v-if="hasRole('project', 'ROLE_DELETE_PROJECT_ID')"
            @click="openSingleDeleteDialog"
          >
            <v-list-item-title>
              {{ $t('Common.deleteProject') }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-btn icon @click="close()">
        <v-icon color="gray-6">close</v-icon>
      </v-btn>
    </div>

    <SingleDeleteDialog
      :visible="singleDeleteDialog"
      :item="data"
      @close="closeSingleDeleteDialog"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { hasRole } from 'utils/functions'
import SingleDeleteDialog from 'components/pages/projects/dialogs/SingleDeleteDialog'

export default {
  name: 'Header',
  props: {
    history: {
      type: Array,
      default: () => []
    },

    data: {
      type: Object,
      required: true
    },

    action: {
      type: String,
      required: true
    }
  },
  components: {
    SingleDeleteDialog
  },
  data () {
    return {
      namespace: 'Components.GlobalDrawer.project.header',
      singleDeleteDialog: false
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    hasRole (group, role) {
      return hasRole(group, role)
    },

    goBack () {
      this.$emit('goBack')
    },

    close (reload = null) {
      this.$emit('close', reload)
    },

    handleEditProject () {
      this.$emit('toggleAction', 'edit')
    },

    openSingleDeleteDialog () {
      this.singleDeleteDialog = true
    },

    closeSingleDeleteDialog (reload) {
      this.singleDeleteDialog = false
      reload && this.close(reload)
    }
  }
}
</script>
